import styled from 'styled-components';
import { theme } from '@upsolve/ui';
import LinkCSS from '../Links/A.css';

const ArticleTile = styled.div`
  margin: 1em 4em 2em;
  padding: 2em 4em;
  border-radius: 8px;
  box-shadow: inset 0 0 0 1px ${theme.colors.white['500']}, 0 5px 15px -5px rgba(0,0,0,.1);
  a { ${LinkCSS} }
  div {
    margin: 1em 0 ;
  }
  small {
    color: ${theme.colors.gray['900']};
    letter-spacing: 1px;
  }
  @media screen and (max-width: 45em) {
    margin: 1em 0;
    padding: 1em 1em;
  }
`;

export default ArticleTile;
